export default {
  client: state => {
    return state.client
  },
  clientInfo: state => {
    return state.clientInfo
  },
  clients: state => {
    return state.clients
  },
  getClientById: (state) => (id) => {
    return state.clients.find(client => client.id === id)
  },
  customBandStyles: state => {
    return state.clientInfo ? state.clientInfo.band_style : ''
  },
  inverseBandStyles: state => {
    return state.clientInfo ? state.clientInfo.inverse_band_style : ''
  },
  borderStyles: state => {
    return state.clientInfo ? state.clientInfo.border_style : ''
  },
  buttonStyles: (state) => (inverse) => {
    if (state.clientInfo) {
      return inverse ? state.clientInfo.inverse_band_style : state.clientInfo.band_style
    }
    return ''
  },
  homeActive: state => {
    return state.homeActive
  },
  categories: state => {
    return state.categories
  },
  languages: state => {
    return state.languages
  }
}
